import { IntegrationListContent } from 'pages/settings/pages/integrations/pages/integrationList/ui/IntegrationListContent'
import { IntegrationListProvider } from 'pages/settings/pages/integrations/context/integrationListContext'

export const IntegrationList = () => (
  <IntegrationListProvider>
    <IntegrationListContent />
  </IntegrationListProvider>
)
